import {$window} from "./globals";

export const mobileNew = () => {
    window.isMobileDevice = (function () {
        return ('ontouchstart' in window);
    })();
    const countDown = $('.CountDown');
    if(countDown.length){
        import('./countdown').then( (module) => {
            module.countDown(countDown, countDown.find('#countdown-timer'));
        });
    }
    const navbarContainer = $('.header__menu .js-navbar .c-navbar__content.container');
    const rightBannerContainer = $('.sidebannersContainer .rightBanner');
    if(window.innerWidth < 1666){
        countDown.appendTo(navbarContainer);
    }
    (new Menu($('#moto-navbar'), $('.c-logobar_container .js-hamburger'), navbarContainer, rightBannerContainer, countDown)).then((mobileMenu) => {
        $('.c-search-form__toggle').on('click',function (){
            const _this = $(this);
            if(mobileMenu.isMobile && _this.hasClass('collapsed')){
                mobileMenu.element.css('margin-top','72px');
                mobileMenu.adjustedMargin = true;
            }else{
                mobileMenu.element.css('margin-top','');
                mobileMenu.adjustedMargin = false;
            }
        });
    });
};

const Menu = async function (element, button, navbarContainer, rightBannerContainer, countDown) {
    this.isMobile = null;
    this.element = element;
    this.button = button;
    this.adjustedMargin = false;
    this.componentRoot = this.element.closest('nav.c-navbar');
    const _this = this;
    function init() {
        const firstChild = _this.element.find('li:first');
        const lastChild = _this.element.find('li:not(.c-toplinks):last');
        let timeout = null;
        resolveType(firstChild,lastChild);
        $window.on('resize',function () {
            clearTimeout(timeout);
            timeout = setTimeout(function (){
                if(this.innerWidth < 1666 && !navbarContainer.find(countDown).length){
                    countDown.appendTo(navbarContainer);
                } else if(this.innerWidth >= 1666 && !rightBannerContainer.find(countDown).length) {
                    countDown.prependTo(rightBannerContainer);
                }
                resolveType(firstChild,lastChild);
            }.bind(this), 100)
        });
        _this.element.find(".dropdown").on('mouseenter', function (e) {

            if (!_this.isMobile && $('ul', this).length) {
                const _$ = $(this);
                const elm = $('ul:first', this);
                const off = elm.offset();
                const l = off.left - _this.element.offset().left;
                const w = elm.width();
                const docW = _this.element.width();
                const isEntirelyVisible = (l + w <= docW);
                if (!isEntirelyVisible) {
                    _$.addClass('edge');
                } else {
                    if(l >= _$.offset().left) {
                        _$.removeClass('edge');
                    }
                }
            }
        });
        _this.element.find(".next-arrow").on('click', function (e) {
            const target = $($(this).attr('data-target'));
            const targetLevel = parseInt(target.attr('class').match(/[0-9]/).pop())*100;
            if(targetLevel !== 100){
                target.addClass('c-navbar__list--is-open');
            }
            _this.element.css('transform','translateX(-'+targetLevel+'%)');
            $([document.documentElement, document.body]).animate({
                scrollTop: 0
            }, 700);
        });
        _this.element.find(".prev-arrow").on('click', function (e) {
            const target = $($(this).attr('data-target'));
            const targetLevel = parseInt(target.attr('class').match(/[0-9]/).pop())*100;
            if(targetLevel !== 100){
                target.addClass('c-navbar__list--is-open');
            }
            const parent = $(this).closest('ul.c-navbar__list');
            _this.element.on('transitionend webkitTransitionEnd oTransitionEnd otransitionend MSTransitionEnd',{parent:parent},waitForTransition);
            _this.element.css('transform','translateX(-'+targetLevel+'%)')
        });
        return _this;
    }

    function waitForTransition(e){
        if(_this.element.is(e.target)) {
            e.data.parent.removeClass('c-navbar__list--is-open');
            _this.element.off('transitionend webkitTransitionEnd oTransitionEnd otransitionend MSTransitionEnd',waitForTransition);
        }
    }

    function resolveType(firstChild,lastChild) {
        const logobar = $('.c-logobar_container');
        if(window.isMobileDevice){
            _this.componentRoot.addClass('mobile').removeClass('desktop');
            _this.isMobile = true;
        }else {
            let wasHidden = false;
            let wasBlock = false;
            if (_this.componentRoot.hasClass('mobile')) {
                if (_this.element.css('display') === 'none') {
                    _this.element.css('display', '');
                    wasHidden = true;
                }
                if (_this.element.css('display') === 'block') {
                    _this.element.css('display', '');
                    wasBlock = true;
                }
                _this.componentRoot.removeClass('mobile').addClass('desktop');
            }
            if (firstChild.offset().top !== lastChild.offset().top) {
                _this.componentRoot.addClass('mobile').removeClass('desktop');
                _this.isMobile = true;
            } else {
                _this.componentRoot.removeClass('mobile').addClass('desktop');
                _this.isMobile = false;
            }

            if (wasHidden) {
                _this.element.css('display', 'none');
            }
            if (wasBlock) {
                _this.element.css('display', 'block');
            }
        }
        _this.element.removeClass('init');
        if(!_this.isMobile) {
            _this.button.css('display', 'none');
            logobar.addClass('noBorder');
            if(_this.adjustedMargin){
                _this.adjustedMargin = false;
                _this.element.css('margin-top','');
            }
            var target = $(_this.button.attr('data-target'));
            if (_this.button.hasClass("c-hamburger--active")) {
                target.find(".c-navbar__list--is-open").removeClass("c-navbar__list--is-open");
                target.find(".c-navbar__dropdown--is-open").removeClass("c-navbar__dropdown--is-open");
                _this.button.toggleClass("c-hamburger--active");
                _this.button.attr("aria-expanded", "false");
                target.removeAttr('style');
            } else {
                target.removeAttr('style');
            }
            _this.button.parent().removeClass('burgerOpened');
        }else{
            _this.button.css('display', 'flex');
            logobar.removeClass('noBorder');
        }
    }

    return init();
};